import { Box, Container, IconButton, Paper, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { getCurrentDate, getCurrentTime } from '../../utils/utility-functions';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import CloseIcon from '@mui/icons-material/Close';
import { Button } from '../new/Button';
import LogoComponent from '../logo/LogoComponent';

const SuccessScreen = () => {
  const navigate = useNavigate();

  const jobCreationResponse = useSelector((state: RootState) => state.upload.jobCreationResponse);

  const currentUser = useSelector((state: RootState) => state.user.currentUser);

  const { state } = useLocation();

  const navigateToDashboard = () => {
    navigate('/');
  };

  const startFlow = () => {
    if (state !== undefined) {
      navigate(`/create-notice/${state?.navigateTo}`);
    } else {
      navigate(`/create-notice/bk-notice`);
    }
  };

  return (
    <div
      style={{
        position: 'relative',
      }}
    >
      <Box sx={{ position: 'absolute', top: 2, left: 5 }}>
        <LogoComponent />
      </Box>
      <Container
        sx={{
          paddingTop: '3.125rem',
          paddingBottom: '3.125rem',
          display: 'flex',
          justifyContent: 'space-between',
          height: '100vh',
          width: '60%',
          alignItems: 'self-start',
        }}
        // maxWidth="lg"
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            marginLeft: '2rem',
          }}
        >
          <Box
            component="section"
            sx={{
              marginBottom: '2rem',
              display: 'flex',
            }}
          >
            <Paper
              sx={{
                border: '0.0625rem solid #cacaca',
                width: '100%',
                p: (theme) => theme.spacing(4),
                marginTop: (theme) => theme.spacing(3),
              }}
            >
              <Typography variant="h5" fontWeight={500}>
                Congratulations, {currentUser.firstName}! Your{' '}
                {state?.navigateTo === 'direct' ? 'mailing' : 'notice'} has been submitted.
              </Typography>
              <Typography sx={{ marginTop: (theme) => theme.spacing(1.5) }}>
                <span style={{ fontWeight: 'bold' }}>Job Number:</span>{' '}
                {jobCreationResponse.trackingNumber || '0123412'}
              </Typography>
              <Typography sx={{ marginTop: (theme) => theme.spacing(1.5) }}>
                {state?.navigateTo !== undefined && state?.navigateTo !== 'direct' && (
                  <>
                    <span style={{ fontWeight: 'bold' }}>
                      {jobCreationResponse.caseNumbers.length > 1 ? 'Case Numbers:' : 'Case Number:'}
                    </span>{' '}
                    {jobCreationResponse.caseNumbers.join(', ') || '0123412'}
                  </>
                )}
              </Typography>
              <Typography sx={{ marginTop: (theme) => theme.spacing(1.5) }}>
                {state?.navigateTo !== undefined && !['legal', 'direct'].includes(state?.navigateTo) && (
                  <>
                    <span style={{ fontWeight: 'bold' }}>Debtor Name:</span>{' '}
                    {jobCreationResponse.debtorName || '0123412'}
                  </>
                )}
              </Typography>
              <Box
                sx={{
                  marginTop: (theme) => theme.spacing(3),
                  display: 'flex',
                  gap: '0.625rem',
                  width: '50%',
                }}
              >
                <Button sx={{ textTransform: 'none' }} type="primary" onClick={startFlow}>
                  Create New Notice
                </Button>
                <Button
                  sx={{
                    textTransform: 'none',
                    fontWeight: '600',
                    ml: 1,
                  }}
                  type="text"
                  onClick={() => navigate('/')}
                >
                  Proceed to Dashboard
                </Button>
              </Box>
            </Paper>
            <IconButton sx={{ p: 0, alignSelf: 'flex-start', mt: 2.5, ml: 1 }} onClick={navigateToDashboard}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box>
            <Typography sx={{fontSize: '0.8125rem'}} variant="caption">
              This page is only a submission receipt to record chain of custody and does not indicate that the
              submission has been processed or completed. On {getCurrentDate()} at {getCurrentTime()}, under job
              number {jobCreationResponse.trackingNumber || '000000'},{' '}
              <a href="https://CertificateofService.com" target="_blank">
                CertificateofService.com
              </a>{' '}
              received a submission from the following source:
              <ul>
                <li>Account: {currentUser.email}</li>
                <li>IP Address: {jobCreationResponse.ipAddress}</li>
                <li>Host: {window.location.hostname}</li>
                <li>Agent: {navigator.userAgent}</li>
              </ul>
              <a target="_blank" href="https://CertificateofService.com">
                CertificateofService.com
              </a>{' '}
              will process the data, then print, collate, fold and insert the documents into envelopes, which will then
              be sealed, postage pre-determined and pre-sorted for distribution via the United States Postal Service.
              Upon entry into the mail stream, the appropriate Certificate of Service or proof of mailing will be
              returned.
            </Typography>
          </Box>
        </Box>
      </Container>
    </div>
  );
};

export default SuccessScreen;
